import slice from './slice';

const dockerImageReducer = slice.reducer;

export const { setFieldDockerImage, addItem, viewItem, removeItem } =
  slice.actions;

export default dockerImageReducer;
